import { useEffect } from 'react';
import { segmentIntegrations } from 'components/shared/analytics/segment';
import { ANXIETY_ASSESSMENT_QUESTIONS } from 'components/shared/analytics/segment-events';
import AssessmentIntro from 'components/assessment-intro';
import { clearAssessmentData } from 'components/shared/utils';
import { useHistory } from 'react-router-dom';

const AnxietySelfTest = (): JSX.Element => {
  const history = useHistory();
  const content = {
    title: 'Anxiety screener',
    description:
      'To complete this evaluation, think about your mental health experiences over the last two weeks.'
  };

  useEffect(() => {
    clearAssessmentData();
  }, []);

  const handleNextPage = () => {
    window.analytics?.track(
      ANXIETY_ASSESSMENT_QUESTIONS,
      { title: content.title },
      segmentIntegrations
    );
    history.push('/anxiety-assessment');
  };

  return (
    <AssessmentIntro
      handleNextPage={handleNextPage}
      title={content.title}
      description={content.description}
    />
  );
};

export default AnxietySelfTest;
